import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useNavigationCssClasses } from '../../hooks';
import { NavLinkButton } from '../NavLinkButton/NavLinkButton';
import { NavSubItem } from '../NavSubItem/NavSubItem';
import './NavItem.scss';
export const NavItem = ({ item, collapsed = false, }) => {
    const { links, path, exact, onClick, headerIcon: HeaderIcon, headerText, disabled, overrideActive, } = item;
    const isListItem = links && links.length > 0;
    const isActive = useRouteMatch({ path, exact });
    const { navItemCss, navItemIconCss } = useNavigationCssClasses({
        collapsed,
        disabled,
        active: overrideActive || isActive,
    });
    return (React.createElement("div", { className: navItemCss },
        React.createElement(NavLinkButton, { path: path, disabled: disabled, collapsed: collapsed, onClick: onClick },
            React.createElement("div", { className: navItemIconCss },
                React.createElement(HeaderIcon, null)),
            React.createElement("div", { className: "nav-item__text" }, headerText)),
        isListItem ? React.createElement(NavSubItem, { list: links, collapsed: collapsed }) : null));
};
//# sourceMappingURL=NavItem.js.map